import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EditTracking from '../editor/EditTracking';

export const initTrackingValues = {
  tracking: {
    content: ['body'],
    close_button: ['close'],
    background: ['background']
  }
};

const BottomSlideUpTracking: FC = () => {
  let tracking = useSelector((state: any) => state.trackings.tracking);

  const style = `
  .root_tracking {
    width: 100%;
    height: 100%;
    
    position: relative;
    background: none;
    overflow: hidden;   
  }
  .tracking_center {
    width: 100%;
    display: flex;
    justify-content: end;
    position: absolute;
    bottom: 60px;
  } 
  .tracking_content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }}></style>
      <div className="root_tracking">
        <div className="tracking_center">
          <div className="tracking_content">
            <div style={{ marginBottom: '100px' }}>
              <EditTracking
                value={tracking?.background?.[0]}
                type="background"
              />
            </div>
            <EditTracking value={tracking?.content?.[0]} type="content" />
            <EditTracking
              value={tracking?.close_button?.[0]}
              type="close_button"
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default BottomSlideUpTracking;
